/* ==========================================================================
   sw-blog.js — Safranwunder Magazin
   Vier unabhängige Module. Jedes prüft selbst, ob sein Markup vorhanden ist,
   damit die Datei in jeder Section einzeln geladen werden kann.
   Kein Framework, keine Abhängigkeiten.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1 · Inhaltsverzeichnis aus allen [data-swb-prose]-Blöcken erzeugen.
         Rendert erst ab data-swb-toc-min Überschriften (Default 4).
     ------------------------------------------------------------------ */
  function initToc() {
    var root = document.querySelector('[data-swb-toc]');
    if (!root || root.getAttribute('data-swb-ready') === 'true') return;
    root.setAttribute('data-swb-ready', 'true');

    var list = root.querySelector('[data-swb-toc-list]');
    var scope = root.getAttribute('data-swb-toc-scope') || '[data-swb-prose]';
    var min = parseInt(root.getAttribute('data-swb-toc-min') || '4', 10);
    var withSubs = root.getAttribute('data-swb-toc-subs') === 'true';
    if (!list) return;
    list.textContent = '';

    var blocks = document.querySelectorAll(scope);
    var headings = [];
    Array.prototype.forEach.call(blocks, function (block) {
      var sel = withSubs ? 'h2, h3' : 'h2';
      Array.prototype.forEach.call(block.querySelectorAll(sel), function (h) {
        if (h.hasAttribute('data-swb-toc-skip')) return;
        if (!h.textContent.trim()) return;
        headings.push(h);
      });
    });

    var mainCount = headings.filter(function (h) { return h.tagName === 'H2'; }).length;
    if (mainCount < min) { root.hidden = true; return; }

    var used = {};
    function slugify(text) {
      var base = text.toLowerCase()
        .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'abschnitt';
      if (used[base] === undefined) { used[base] = 0; return base; }
      used[base] += 1;
      return base + '-' + used[base];
    }

    var currentSub = null;
    var links = [];

    headings.forEach(function (h) {
      if (!h.id) h.id = slugify(h.textContent.trim());
      else used[h.id] = 0;

      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      var li = document.createElement('li');
      li.appendChild(a);
      links.push({ link: a, heading: h });

      if (h.tagName === 'H3') {
        if (!currentSub) {
          currentSub = document.createElement('ol');
          currentSub.className = 'swb-toc__sub';
          var last = list.lastElementChild;
          (last || list).appendChild(currentSub);
        }
        currentSub.appendChild(li);
      } else {
        currentSub = null;
        list.appendChild(li);
      }
    });

    root.hidden = false;

    /* Scroll-Spy */
    if (!('IntersectionObserver' in window)) return;
    var visible = new Map();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.set(entry.target, entry.boundingClientRect.top);
        else visible.delete(entry.target);
      });
      var active = null;
      links.forEach(function (item) { if (visible.has(item.heading) && !active) active = item.heading; });
      if (!active) return;
      links.forEach(function (item) {
        if (item.heading === active) item.link.setAttribute('aria-current', 'true');
        else item.link.removeAttribute('aria-current');
      });
    }, { rootMargin: '-80px 0px -70% 0px', threshold: 0 });

    links.forEach(function (item) { observer.observe(item.heading); });
  }

  /* ------------------------------------------------------------------
     2 · Lesefortschritt
     ------------------------------------------------------------------ */
  function initProgress() {
    var bar = document.querySelector('[data-swb-progress]');
    if (!bar || bar.getAttribute('data-swb-ready') === 'true') return;
    bar.setAttribute('data-swb-ready', 'true');
    var target = document.querySelector(bar.getAttribute('data-swb-progress') || 'main') || document.body;
    var ticking = false;

    function update() {
      var rect = target.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var done = total > 0 ? Math.min(Math.max(-rect.top / total, 0), 1) : 0;
      bar.style.width = (done * 100).toFixed(2) + '%';
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ------------------------------------------------------------------
     3 · Portionsrechner (Rezept)
     ------------------------------------------------------------------ */
  function initPortions() {
    var root = document.querySelector('[data-swb-portions]');
    if (!root || root.getAttribute('data-swb-ready') === 'true') return;
    root.setAttribute('data-swb-ready', 'true');

    var base = parseInt(root.getAttribute('data-swb-portions') || '4', 10);
    var minP = parseInt(root.getAttribute('data-swb-portions-min') || '1', 10);
    var maxP = parseInt(root.getAttribute('data-swb-portions-max') || '12', 10);
    var label = root.getAttribute('data-swb-portions-label') || 'Portionen';
    var labelOne = root.getAttribute('data-swb-portions-label-one') || label.replace(/en$/, '');
    var out = root.querySelector('[data-swb-portions-value]');
    var dec = root.querySelector('[data-swb-portions-dec]');
    var inc = root.querySelector('[data-swb-portions-inc]');
    var amounts = document.querySelectorAll('[data-swb-amount]');
    var yieldOut = document.querySelectorAll('[data-swb-yield]');
    var current = base;

    function format(n) {
      // Epsilon gegen Float-Artefakte: 0,225 soll zu 0,23 werden, nicht zu 0,22.
      var eps = 1e-9;
      if (n >= 100) return String(Math.round(n + eps));
      if (n >= 10) return String(Math.round(n * 10 + eps) / 10).replace('.', ',');
      return String(Math.round(n * 100 + eps) / 100).replace('.', ',');
    }

    function render() {
      if (out) out.textContent = current + ' ' + (current === 1 ? labelOne : label);
      Array.prototype.forEach.call(amounts, function (el) {
        var per = parseFloat(el.getAttribute('data-swb-amount'));
        if (isNaN(per)) return;
        var unit = el.getAttribute('data-swb-unit') || '';
        var dec = el.getAttribute('data-swb-decimals');
        var scaled = per * current / base;
        var text = dec !== null
          ? scaled.toFixed(parseInt(dec, 10)).replace('.', ',')
          : format(scaled);
        el.textContent = text + (unit ? ' ' + unit : '');
      });
      Array.prototype.forEach.call(yieldOut, function (el) { el.textContent = String(current); });
      if (dec) dec.disabled = current <= minP;
      if (inc) inc.disabled = current >= maxP;
    }

    if (dec) dec.addEventListener('click', function () { if (current > minP) { current -= 1; render(); } });
    if (inc) inc.addEventListener('click', function () { if (current < maxP) { current += 1; render(); } });
    render();
  }

  /* ------------------------------------------------------------------
     4 · FAQ — nur ein Panel zugleich offen (optional per data-Attribut)
     ------------------------------------------------------------------ */
  function initFaqExclusive() {
    var list = document.querySelector('[data-swb-faq-exclusive]');
    if (!list || list.getAttribute('data-swb-ready') === 'true') return;
    list.setAttribute('data-swb-ready', 'true');
    var items = list.querySelectorAll('details');
    Array.prototype.forEach.call(items, function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        Array.prototype.forEach.call(items, function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function boot() {
    initToc();
    initProgress();
    initPortions();
    initFaqExclusive();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
